<template lang="pug">
  div
    Toolbar

    .body-container#home
      .header-container
        b-img.header-image(src="@/assets/home-background.png")
        b-container
          .header-text.text-center(style="padding-top:66px;")
            h1 SERVICIOS SUBCONTRATADOS
            h1.mb-3.mb-lg-4 PARA LA OPERACIÓN DE EDIFICIOS
            b-button.br-10.px-3.py-2(variant="primary", v-scroll-to="{element: '#about-us', offset:-60}") Conocer más

      .section#about-us
        b-container
          b-row.align-items-center
            b-col(md="5")
              .p-3
                b-img.mb-4.mb-md-0(src="@/assets/chem-1.png", fluid, center)
            b-col(md="7")
              p.text-secondary Acerca de CYR Operación de Inmuebles
              h4.mb-3 Somos una empresa vanguardista que proporciona soluciones integrales
              p.text-secondary CYR Operación de Inmuebles S.A. de C.V. nace en abril del 2006 con el principal objetivo de ser una empresa vanguardista que proporcione soluciones integrales en la operación de edificios y que participe en el progreso del cliente; de esta manera buscamos crear una sociedad de negocios.
              p Nuestra finalidad se compone de la provisión de soluciones idóneas, vanguardistas, a costos accesibles y con alto soporte técnico directo, sustentada en alianzas estratégicas de la mano de fabricantes y desarrolladores de tecnología para inmuebles.

      .section.bg-blue.py-3.text-center#services
        .section
          b-container
            p.text-secondary Servicios
            h4.font-weight-bold.mb-4.mb-lg-5 En CYR buscamos ser tu mejor opción si estás buscando 
              br
              | soluciones eficientes en temas de outsourcing.

            b-row
              b-col(md="6", offset-md="3")
                div.text-left.mb-4.mb-lg-5(v-for="(data, index) in list", :key="index")
                  h3.font-weight-bold.mb-3.mb-lg-4(@click="data.expanded = !data.expanded", style="cursor:pointer;")
                    plus-circle-icon.mr-2(v-if="data.expanded == false")
                    minus-icon.mr-2(v-else-if="data.expanded == true")
                    span {{ data.title }}
                  p.text-secondary {{ data.subtitle }}
                  b-collapse.px-3(v-model="data.expanded", v-if="data.list")
                    p(v-for="item in data.list")
                      check-circle-icon(style="width:15px;height:15px;").mr-2
                      span {{ item }}
                  b-button(variant="primary", v-if="data.button", pill, :href="data.link", :target="data.target") {{ data.button }}

      .section.bg-blue.py-3.text-center#contact
        .section
          b-container
            p.text-secondary Solicita una cotización
            h1.font-weight-bold.mb-3 Contáctanos
          .section.text-left.pb-0
            b-container
              validation-observer(ref="person_observer", v-slot="{ invalid, handleSubmit, errors }")
                b-form(@submit.prevent="handleSubmit(sendData)")
                  b-row
                    b-col(offset="1")
                      p.mb-2 Nombre*
                  b-row
                    b-col(cols="5", offset="1")
                      validation-provider(rules="required",  v-slot="{ valid, errors }", name="nombre")
                        b-form-group(description="Nombre")
                          b-form-input.form-input(:state="errors[0] ? false : (valid ? true : null)", v-model="form.first_name")
                    b-col(cols="5")
                      validation-provider(rules="required",  v-slot="{ valid, errors }", name="apellido")
                        b-form-group(description="Apellido")
                          b-form-input.form-input(:state="errors[0] ? false : (valid ? true : null)", v-model="form.last_name")

                  b-row
                    b-col(cols="5", offset="1")
                      validation-provider(rules="required|email",  v-slot="{ valid, errors }", name="email")
                        b-form-group(label="Email*", :description="errors[0] ? 'Ingresa un correo válido' : ''")
                          b-form-input.form-input(:state="errors[0] ? false : (valid ? true : null)", v-model="form.email")
                    b-col(cols="5")
                      validation-provider(rules="required|numeric",  v-slot="{ valid, errors }", name="teléfono")
                        b-form-group(label="Teléfono*", :description="errors[0] ? 'Ingresa tu teléfono sin espacios ni guiones' : ''")
                          b-form-input.form-input(:state="errors[0] ? false : (valid ? true : null)", v-model="form.phone")

                  b-row.mb-4
                    b-col(cols="10", offset="1")
                      validation-provider(rules="required",  v-slot="{ valid, errors }", name="mensaje")
                        b-form-group(label="Mensaje*")
                          b-form-textarea.form-input(:state="errors[0] ? false : (valid ? true : null)", v-model="form.message")
                  b-row
                    b-col.text-center(cols="10", offset="1")
                      b-button.br-10.py-2.px-5.text-white(variant="primary", type="submit" :disabled="isLoading || sent") {{sent ? 'Mensaje enviado' : 'Enviar'}}
                      p.text-danger {{error}}
      .section.text-center
        b-container
          p.mb-0.text-secondary Derechos reservados CYR Operaciones de Inmuebles S.A. de C.V. 2020
          small Website by #[a(href="https://torque.studio" target="_blank") Torque.Studio]
</template>

<script>
import Toolbar from '@/components/Toolbar.vue'
import areas from '@/data/areas'
import prices from '@/data/prices'
import axios from 'axios'

import list from '@/data/list'

export default {
  data () {
    return {
      isLoading: false,
      sent: false,
      error: null,
      areas: areas,
      prices: prices,
      list: list,
      form: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        message: null
      }
    }
  },
  components: {
    Toolbar
  },
  methods: {
    generateImage (image) {
      if (!image) return
      return require('@/assets/' + image);
    },
    sendData () {
      this.isLoading = true
      this.sent = false
      this.error = null

      axios.post('http://cyroi.com/services/sendMail.php', this.form)
        .then(response => {
          this.isLoading = false
          this.sent = true
        })
        .catch(error => {
          this.isLoading = false
          this.error = error
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/theme.scss';

  .header-container {
    position: relative;
    height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .header-text {
      width: 100%;
      position: relative;
      z-index: 1;
      text-align: left;
      color: white;
      text-shadow: 2px 3px 5px #333;

      h1 {
        text-transform: uppercase;
      }
    }
  }

  .mw-md-70 {
    @media (min-width: 768px) {
      max-width: 70%;
    }
  }

  .header-image {
    object-fit:cover;
    object-position:bottom;
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
  }

  .section {
    padding: 1.5rem 0;

    @media (min-width: 768px) {
      padding: 3rem 0;
    }

    &.bg-blue {
      background: $background-blue;
    }
  }

  .light-blue {
    color: #3A9BD7;
  }

  .blue-card {
    text-align: left;
    color: white;
    border-radius: 10px;

    &.left {
      @media (min-width: 768px) {
        margin-left:-80px;
      }
    }

    &.right {
      @media (min-width: 768px) {
        margin-right:-80px;
      }
    }

    ul {
      margin: 0;
      padding: 0;
      list-style-type: none;
    }
  }

  .table-price div {
    &:not(:last-child) {
      margin-bottom: .5rem;
    }
  }

  .text-sm {
    font-size: 13px;
  }

  .form-input {
    border-color: white;
  }
</style>
